import BotoesSalvarExcluir from '@/shared/components/forms/BotoesSalvarExcluir';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import { CreateTipoGastoDto, ReadTipoGastoDto, UpdateTipoGastoDto } from '@/api.types';
import { DeleteTipoGasto, GetTipoGastos, SetTipoGasto } from './tipo-gasto.service';
import { resolveTipoGastoIcone } from './tipo-gasto-icones';
import { TipoGastoIconeSelect } from './TipoGastoIconeSelect';
import { Modal } from 'react-bootstrap';
import { SubmitHandler, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { LuPlus } from 'react-icons/lu';

interface ModalTipoGastosProps {
  show: boolean;
  onHide: () => void;
  onChanged: () => void;
}

const COR_PADRAO = '#0d6efd';

const formVazio = {
  id: 0,
  descricao: '',
  coluna1: '',
  coluna2: '',
  coluna3: '',
  icone: null,
  cor: COR_PADRAO,
} as ReadTipoGastoDto;

export function ModalTipoGastos({ show, onHide, onChanged }: ModalTipoGastosProps) {
  const [tipos, setTipos] = useState<ReadTipoGastoDto[]>([]);
  const [selecionadoId, setSelecionadoId] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(false);
  const [listaLoading, setListaLoading] = useState(false);
  const [modalExcluirShow, setModalExcluirShow] = useState(false);

  const { register, handleSubmit, reset, watch, setValue } = useForm<ReadTipoGastoDto>({
    defaultValues: formVazio,
  });

  const iconeSelecionado = watch('icone');
  const corSelecionada = watch('cor') || COR_PADRAO;
  const btnSalvar = selecionadoId > 0 ? 'Salvar' : 'Cadastrar';

  const carregarTipos = (manterSelecaoId?: number) => {
    setListaLoading(true);
    return GetTipoGastos(0, 1000)
      .then((result) => {
        setTipos(result.objects);
        if (manterSelecaoId != null && manterSelecaoId > 0) {
          const encontrado = result.objects.find((t) => t.id === manterSelecaoId);
          if (encontrado) {
            setSelecionadoId(encontrado.id);
            reset(encontrado);
            return;
          }
        }
        if (selecionadoId > 0) {
          const atual = result.objects.find((t) => t.id === selecionadoId);
          if (atual) {
            reset(atual);
            return;
          }
        }
      })
      .catch((res) => {
        toast.error(String(res));
      })
      .finally(() => setListaLoading(false));
  };

  useEffect(() => {
    if (!show) return;
    setSelecionadoId(0);
    reset(formVazio);
    carregarTipos();
  }, [show]);

  const selecionarTipo = (tipo: ReadTipoGastoDto) => {
    setSelecionadoId(tipo.id);
    reset(tipo);
  };

  const novoTipo = () => {
    setSelecionadoId(0);
    reset(formVazio);
  };

  const onSubmit: SubmitHandler<ReadTipoGastoDto> = (data) => {
    setIsLoading(true);

    const dataToSave: CreateTipoGastoDto | UpdateTipoGastoDto = {
      id: selecionadoId > 0 ? selecionadoId : undefined,
      descricao: data.descricao || '',
      coluna1: data.coluna1 || undefined,
      coluna2: data.coluna2 || undefined,
      coluna3: data.coluna3 || undefined,
      icone: data.icone || null,
      cor: data.cor || COR_PADRAO,
    };

    SetTipoGasto(dataToSave)
      .then((res) => {
        toast.success(String(res));
        onChanged();
        return GetTipoGastos(0, 1000).then((result) => {
          setTipos(result.objects);
          if (selecionadoId > 0) {
            const atual = result.objects.find((t) => t.id === selecionadoId);
            if (atual) {
              reset(atual);
              return;
            }
          }
          const criado = result.objects.find(
            (t) => t.descricao === dataToSave.descricao
          );
          if (criado) {
            setSelecionadoId(criado.id);
            reset(criado);
          } else {
            novoTipo();
          }
        });
      })
      .catch((res) => {
        toast.error(String(res));
      })
      .finally(() => setIsLoading(false));
  };

  const handleExcluir = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (selecionadoId <= 0) return;

    setModalExcluirShow(false);
    DeleteTipoGasto(selecionadoId)
      .then((res) => {
        toast.success(String(res));
        onChanged();
        novoTipo();
        carregarTipos();
      })
      .catch((res) => {
        toast.error(String(res));
      });
  };

  return (
    <>
      <Modal show={show} onHide={onHide} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Tipos de Gasto</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="row g-0">
            <div className="col-md-4 border-end">
              <div className="p-3 border-bottom d-flex justify-content-between align-items-center">
                <strong className="small text-muted text-uppercase">Lista</strong>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1"
                  onClick={novoTipo}
                >
                  <LuPlus size={14} aria-hidden />
                  Novo
                </button>
              </div>
              <div className="list-group list-group-flush" style={{ maxHeight: 480, overflowY: 'auto' }}>
                {listaLoading && (
                  <div className="list-group-item text-muted small">Carregando...</div>
                )}
                {!listaLoading && tipos.length === 0 && (
                  <div className="list-group-item text-muted small">Nenhum tipo cadastrado.</div>
                )}
                {tipos.map((tipo) => {
                  const Icone = resolveTipoGastoIcone(tipo.icone);
                  const ativo = selecionadoId === tipo.id;
                  return (
                    <button
                      key={tipo.id}
                      type="button"
                      className={`list-group-item list-group-item-action d-flex align-items-center gap-2 ${ativo ? 'active' : ''}`}
                      onClick={() => selecionarTipo(tipo)}
                    >
                      {Icone ? (
                        <Icone size={16} aria-hidden style={{ color: ativo ? undefined : tipo.cor || COR_PADRAO }} />
                      ) : (
                        <span style={{ width: 16 }} />
                      )}
                      <span className="text-truncate">{tipo.descricao}</span>
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="col-md-8">
              <div className="p-3">
                <h6 className="mb-3">
                  {selecionadoId > 0 ? 'Editar tipo' : 'Novo tipo'}
                </h6>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="row g-2 align-items-end mb-3">
                    <div className="col-auto">
                      <label className="form-label" htmlFor="modal-tipo-cor">
                        Cor:
                      </label>
                      <input
                        id="modal-tipo-cor"
                        type="color"
                        className="form-control form-control-color"
                        title="Cor do ícone"
                        value={corSelecionada}
                        onChange={(e) => setValue('cor', e.target.value, { shouldDirty: true })}
                      />
                      <input type="hidden" {...register('cor')} />
                    </div>
                    <div className="col-auto">
                      <label className="form-label" htmlFor="modal-tipo-icone">
                        Ícone:
                      </label>
                      <input type="hidden" {...register('icone')} />
                      <TipoGastoIconeSelect
                        id="modal-tipo-icone"
                        value={iconeSelecionado}
                        cor={corSelecionada}
                        onChange={(icone) => setValue('icone', icone, { shouldDirty: true })}
                      />
                    </div>
                    <div className="col">
                      <label htmlFor="modal-tipo-descricao" className="form-label">
                        Descrição: *
                      </label>
                      <input
                        id="modal-tipo-descricao"
                        type="text"
                        className="form-control"
                        {...register('descricao', { required: true })}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="mb-3 col-md-4">
                      <label htmlFor="modal-coluna1" className="form-label">
                        Nome da Coluna 1:
                      </label>
                      <input
                        id="modal-coluna1"
                        type="text"
                        className="form-control"
                        {...register('coluna1')}
                      />
                    </div>
                    <div className="mb-3 col-md-4">
                      <label htmlFor="modal-coluna2" className="form-label">
                        Nome da Coluna 2:
                      </label>
                      <input
                        id="modal-coluna2"
                        type="text"
                        className="form-control"
                        {...register('coluna2')}
                      />
                    </div>
                    <div className="mb-3 col-md-4">
                      <label htmlFor="modal-coluna3" className="form-label">
                        Nome da Coluna 3:
                      </label>
                      <input
                        id="modal-coluna3"
                        type="text"
                        className="form-control"
                        {...register('coluna3')}
                      />
                    </div>
                  </div>

                  <BotoesSalvarExcluir
                    isLoading={isLoading}
                    texto={btnSalvar}
                    textoLoading={btnSalvar === 'Cadastrar' ? ' Cadastrando...' : ' Salvando...'}
                    id={selecionadoId}
                    onExcluirClick={() => setModalExcluirShow(true)}
                  />
                </form>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <ModalExcluir
        show={modalExcluirShow}
        handleExcluir={handleExcluir}
        handleHide={() => setModalExcluirShow(false)}
      />
    </>
  );
}
